import React from 'react';
import { useTranslation } from 'react-i18next';
import './TagFilter.css';

const TagFilter = ({
  availableTagCategories,
  activeTagCategory,
  activeTag,
  onChangeTagCategory,
  onChangeTag,
  allLabel,
}) => {
  const { t } = useTranslation();
  const categories = Object.keys(availableTagCategories || {});
  if (categories.length === 0) return null;

  const resolvedAllLabel = allLabel ?? t('createPage.allStyles', 'All');

  return (
    <div className="tag-filter-container">
      <div className="tag-category-tabs">
        {categories.map(category => {
          const catClass = `cat-${category.toLowerCase()}`;
          return (
            <button
              type="button"
              key={category}
              className={`tag-category-label ${catClass} ${activeTagCategory === category ? 'active' : ''}`}
              onClick={() => {
                onChangeTagCategory?.(category);
                onChangeTag?.(null);
              }}
            >
              {category}
            </button>
          );
        })}
      </div>
      {activeTagCategory && availableTagCategories[activeTagCategory] && (
        <div className={`tag-category-row cat-${activeTagCategory.toLowerCase()}`}>
          <div className="tag-category-chips">
            <button
              type="button"
              className={`tag-chip tag-clear ${activeTag === null ? 'active' : ''}`}
              onClick={() => onChangeTag?.(null)}
            >
              {resolvedAllLabel}
            </button>
            {availableTagCategories[activeTagCategory].map(tag => (
              <button
                type="button"
                key={tag}
                className={`tag-chip ${activeTag === tag ? 'active' : ''}`}
                onClick={() => onChangeTag?.(tag)}
              >
                {tag}
              </button>
            ))}
          </div>
        </div>
      )}
    </div>
  );
};

export default TagFilter;
